import CreateMockExam from '@/features/create-mock-exam'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/create-mock-exam/$moduleId/$classId')({
  component: CreateMockExamWrapper,
})

function CreateMockExamWrapper() {
  const { moduleId, classId } = Route.useParams() as { moduleId: string; classId: string }
  return <CreateMockExam key={`${moduleId}-${classId}`} moduleId={moduleId} classId={classId} />
}

export default Route
